import React, { useState, useEffect } from 'react'

const StudentFeeDiscountBreakdown = props => {
  const [state, setState] = useState({
    discRow: props.discRow,
    discountData: props.discountData,
    wId: props.wId,
    studentId: props.studentId,
    studentName: props.studentName,
    feeStudentId: props.feeStudentId,
    lstDiscount: props.lstDiscount,
    // keySummary: props.keySummary
  })
  const [tDiscount, setTDiscount] = useState(0)
  var error = 0;
  useEffect(() => {
    setPayment()
  }, [])

  const setPayment = () => {
    var feeNodes = document.querySelector('.fee')
    let tot = 0;
    for (let i = 0; i < state.discountData.length; i++) {

      var obj = state.discountData[i]
      tot += parseInt(obj.amt)
    }
    setTDiscount(tot)
  }

  const handleDiscAmt = async (e, discountId) => {
    if (!e.target.value.trim()) {
      return false;
    }
    var disc = parseInt(e.target.value)
    // console.log('handleDiscAmt() called: amt', disc, ', discId', discountId, ', studentId:', state.studentId, ', wId:', state.wId)
    var lstData = state.discountData;

    var tot = 0
    for (var k = 0; k < lstData.length; k++) {
      var obj = lstData[k]
      if (obj.discountId === discountId) {
        obj.amt = parseInt(disc);
      }
      tot += parseInt(isNaN(obj.amt) ? 0 : obj.amt)
    }
    setTDiscount(tot)
    setState({ ...state, discountData: lstData })
  }

  const handleRemarks = async (e, discountId) => {
    var remarks = e.target.value.trim();
    // console.log('handleRemarks() called:', remarks, discountId, state.studentId, state.wId)
    var lstData = state.discountData.map(item =>
      item.discountId === discountId
        ? { ...item, remarks }
        : item
    );
    setState(prev => ({
      ...prev,
      discountData: lstData
    }));
  }

  function applyStudentDiscount() {
    var lstData = state.discountData;
    // console.log('apply btn pressed', lstData, lstData.length);

    var tot = 0;
    for (var k = 0; k < lstData.length; k++) {
      var obj = lstData[k];
      if (obj.remarksMandatory == 1 && obj.amt > 0) {
        if (obj.remarks.trim().length == 0) {
          document.getElementById(`wId_${state.wId}_dInp_${obj.discountId}`).style.border = '1px solid red';
          error += 1;
        } else {
          document.getElementById(`wId_${state.wId}_dInp_${obj.discountId}`).style.border = '';
        }
      }
      
      tot += obj.amt;
    }

    if (error < 1) {
      props.setDiscRow({ ...state.discRow, discountAmt: tot, discountData: lstData })
      props.updateDiscountAmount(state.wId, lstData, tot)
      document.getElementById(`wId_${state.wId}_dInp_${obj.discountId}`).style.border = "";
      props.setFlgDiscountUpdated(generateRandomNo);
      closeClick();
    }
  }
  const generateRandomNo = () => {
    return Math.floor(Math.random() * 999999)
  }
  function closeClick() {
    props.closePopup()
  }

  return (
    <>
      {/* <h6 className='text-left'>Receipt No.: {props.month}</h6> */}
      <table className='tableLayout1'>
        <thead>
          <tr>
            <th style={{ width: 40 }}> Discount</th>
            <th style={{ width: 40 }}> Amount</th>
            <th style={{ width: 80 }}> Remarks</th>
          </tr>
        </thead>
      </table>
      <div className='tableDivSmall' style={{ height: 210 }}>
        <table id='feeDueDtlsTable' className='tableLayout'>
          <tbody id='feeDueDtlsTableBody'>
            {state.discountData.map((feeDtls, i) => (
              <tr key={feeDtls.discountId}>
                <td width='40' className='no-display'>
                  {feeDtls.discountId}
                </td>
                <td key={feeDtls.feeHeadCode} width='40' className='text-left'>
                  {feeDtls.discountLabel}
                </td>
                <td
                  key={'disc_' + feeDtls.discountId + '_stu_' + state.studentId}
                  width='40'
                  className='text-left fee-lbl'
                >
                  <input type="text" key={'disInp_' + feeDtls.discountId + '_stu_' + state.studentId}
                    onChange={(e) => handleDiscAmt(e, feeDtls.discountId)}
                    className="form-control text-right fee"
                    defaultValue={feeDtls.amt}
                    id={`dInp_${feeDtls.discountId}`} />
                </td>
                <td
                  key={'lbl_' + feeDtls.label}
                  width='120'
                  className='text-left fee-lbl'
                >
                  <input type="text"
                    key={'disRemInp_' + feeDtls.discountId + '_wId_' + state.wId + '_stu_' + state.studentId}
                    // onKeyDown={(e) => handleRemarks(e, feeDtls.discountId)}
                    onChange={(e) => handleRemarks(e, feeDtls.discountId)}
                    className="form-control"
                    defaultValue={feeDtls.remarks}
                    // value={feeDtls.remarks}
                    id={`wId_${state.wId}_dInp_${feeDtls.discountId}`} />

                </td>
              </tr>
            ))}
            <tr style={{ background: '#d5dfe9', fontWeight: 'bold' }}>
              <td></td>
              <td className='text-right'> {tDiscount}</td>
              <td></td>
            </tr>

          </tbody>
        </table>
      </div>
      <div className='col-sm-12' style={{ marginTop: '1%', bottom: '1%' }}>
        <button
          type='button'
          className='btn btn-info pull-right'
          onClick={() => applyStudentDiscount()}
        >
          Apply
        </button>
      </div>
    </>
  )
}

export default StudentFeeDiscountBreakdown;